import iconRefresh from "@assets/images/refresh.svg";
import iconSearch from "@assets/images/Search.png";
import { Button } from "@material-ui/core";
import InputSearch from "@saleor/components/InputSearch";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React, { useState } from "react";

interface CartSearchBarProps {
  value?: string;
  onChange: (value: string) => void;
  onReset: () => void;
  searchId: string;
  loading?: boolean;
}

const useStyle = makeStyles(
  theme => ({
    searchInput: {
      display: "flex"
    },
    info: {
      marginTop: "2rem",
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: "0.7rem"
      }
    },
    button: {
      height: "4rem",
      width: "6.4rem"
    },
    formControl: {
      display: "grid",
      gridTemplateColumns: "1fr 3fr",
      gridGap: "1rem",
      alignItems: "end",
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 11px) scale(1)",
        "&.MuiInputLabel-shrink": {
          transform: "translate(12px, 7px) scale(0.75)"
        }
      },
      "& .MuiInputBase-input": {
        paddingTop: "9px",
        "&.Mui-disabled": {
          background: theme.palette.grey[300],
          color: theme.palette.grey[900],
          pointerEvents: "none"
        }
      },
      "& .MuiOutlinedInput-root": {
        height: "4rem",
        "&.Mui-disabled": {
          background: theme.palette.grey[300],
          pointerEvents: "none",
          border: 0
        }
      }
    },
    cannotClick: {
      border: `1px solid ${theme.palette.background.default}`,
      background: theme.palette.background.default,
      "& fieldset": {
        borderColor: theme.palette.background.default
      },
      "& input": {
        color: theme.palette.grey[900]
      }
    },
    inputRoot: {
      height: "40px"
    }
  }),
  { name: "ShoppingCartExport" }
);

const CartSearchBar: React.FC<CartSearchBarProps> = ({
  searchId,
  onChange,
  onReset
}) => {
  const classes = useStyle();

  const [value, setValue] = useState<string>("");

  const handleSearch = () => {
    if (value) {
      onChange(value);
    }
  };

  const handleChange = event => {
    setValue(event);
  };

  const handleReset = () => {
    setValue("");
    onChange("");
    onReset();
  };
  return (
    <div className={classes.formControl}>
      {/* <NumberInput
        onChange={handleChange}
        placeholder={"ค้นหา"}
        error={error}
        value={value}
        className={classNames(classes.inputRoot, {
          [classes.cannotClick]: searchId
        })}
        maxLength={10}
      /> */}
      <InputSearch
        isReset={!searchId}
        variant="outlined"
        placeholder="ค้นหา"
        inputType="string"
        maxLength={30}
        disabled={!!searchId}
        regex={/[^0-9A-Za-z]/g}
        value={searchId}
        onChangeProps={handleChange}
        id="input-search-pi-sold-to"
        name="input-search-pi-sold-to"
        data-testid="input-search-pi-sold-to"
      />
      {!searchId ? (
        <Button
          variant="contained"
          color="secondary"
          className={classNames(classes.button, "defaultB")}
          onClick={handleSearch}
          name="search-button"
          id="search-button"
          data-testid="search-button"
        >
          <img src={iconSearch} alt="search" />
        </Button>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          className={classNames(classes.button, "defaultB")}
          onClick={handleReset}
          name="reset-button"
          id="reset-button"
          data-testid="reset-button"
        >
          <img src={iconRefresh} alt="search" />
        </Button>
      )}
    </div>
  );
};

export default CartSearchBar;
